<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" :disabled="isLoading" data-vv-scope="form" @submit.prevent="onBeforeSaveItem">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-description"
                                    name="description"
                                    v-model.trim="form.description"
                                    v-validate="'required|max:250'"
                                    :inputClasses="[{'is-invalid': fnHasError(`description`) }]"
                                    :error="fnFirstError(`description`)" :helpText="texts.description.help" >
                                    {{texts.description.label}}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="onBeforeSaveItem"
                        @cancel="handleBack(moduleInternalCode + '.municipal_works_applicant', true)"
                    />
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../../../mixin';

    export default {
        mixins: [mixin],
        data() {
            return {
                pageID: 'municipal_works_applicant',
                form: {
                    id: null,
                    description: ''
                },
                texts : { 
                    description: {
                        label:"Descrição",
                        help: ""
                    },
                },
                lists: {
                    loaded: false,
                },
            }
        },
        methods: {
            onBeforeSaveItem() {
                this.saveItem(false)
            },
        },
    }
</script>